<template>
  <component
    :is="tag"
    class="dropdown"
    :class="[{ show: isOpen }, `drop${direction}`]"
    @click="toggleDropDown"
    v-click-outside="closeDropDown"
  >
    <slot name="title-container" :is-open="isOpen">
      <component
        :is="titleTag" :style="{'border': '1px solid ' + (borderColor || textColor)}"
        class="dropdown-toggle no-caret"
        :class="titleClasses"
        :aria-label="title || 'dropdown'"
        :aria-expanded="isOpen"
        data-toggle="dropdown"
      >
        <slot name="title" :is-open="isOpen">
          <div class="row">
            <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 100%;"
                 class="col-9 text-left" :style="{'color': textColor, 'font-family': fontFamily}">
              {{ title }}
            </div>
            <div class="col text-right" >
              <i :style="{'color': textColor}" class="tim-icons icon-minimal-down"></i>
            </div>
          </div>
        </slot>
      </component>
    </slot>
    <ul
      class="dropdown-menu"
      :class="[
        { show: isOpen },
        { 'dropdown-menu-right': menuOnRight },
        menuClasses
      ]"
      ref="menu"
      @scroll="handleScroll"
    >
      <slot></slot>
      <div
        v-if="showScrollIndicator"
        class="scroll-indicator"
        @click.stop="scrollToBottom"
      >
        <i class="tim-icons icon-minimal-down"></i>
      </div>
    </ul>
  </component>
</template>
<script>
export default {
  name: 'base-dropdown',
  props: {
    tag: {
      type: String,
      default: 'div',
      description: 'Dropdown html tag (e.g div, ul etc)'
    },
    titleTag: {
      type: String,
      default: 'button',
      description: 'Dropdown title (toggle) html tag'
    },
    title: {
      type: String,
      description: 'Dropdown title'
    },
    direction: {
      type: String,
      default: 'down', // up | down
      description: 'Dropdown menu direction (up|down)'
    },
    icon: {
      type: String,
      description: 'Dropdown icon'
    },
    titleClasses: {
      type: [String, Object, Array],
      description: 'Title css classes'
    },
    menuClasses: {
      type: [String, Object],
      description: 'Menu css classes'
    },
    menuOnRight: {
      type: Boolean,
      description: 'Whether menu should appear on the right'
    },
    textColor: {
      type: String,
      description: 'Inner text and border color'
    },
    borderColor: {
      type: String,
      description: 'Border color for the trigger; falls back to textColor when unset'
    },
    fontFamily: {
      type: String,
      description: 'Font family'
    }
  },
  data() {
    return {
      isOpen: false,
      showScrollIndicator: false
    };
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.$nextTick(() => this.updateScrollIndicator());
      }
    }
  },
  methods: {
    toggleDropDown() {
      this.isOpen = !this.isOpen;
      this.$emit('change', this.isOpen);
    },
    closeDropDown() {
      this.isOpen = false;
      this.$emit('change', false);
    },
    updateScrollIndicator() {
      const menu = this.$refs.menu;
      if (!menu) return;
      this.showScrollIndicator = menu.scrollHeight > menu.clientHeight && menu.scrollTop + menu.clientHeight < menu.scrollHeight - 5;
    },
    handleScroll() {
      this.updateScrollIndicator();
    },
    scrollToBottom() {
      const menu = this.$refs.menu;
      if (!menu) return;
      menu.scrollTo({ top: menu.scrollHeight, behavior: 'smooth' });
    }
  }
};
</script>
<style lang="scss" scoped>
.dropdown {
  cursor: pointer;
  user-select: none;
}

.dropdown-menu {
  max-height: 150px; /* Adjust this value as needed */
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin; /* For Firefox */
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent; /* For Firefox */
}

/* For Webkit-based browsers (Chrome, Safari) */
.dropdown-menu::-webkit-scrollbar {
  width: 6px;
}

.dropdown-menu::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 3px;
}

.dropdown-menu::-webkit-scrollbar-track {
  background: transparent;
}

.scroll-indicator {
  position: sticky;
  bottom: 4px;
  width: 100%;
  text-align: center;
  pointer-events: auto;
  background: linear-gradient(to bottom, transparent, white);
  padding: 4px 0;
  cursor: pointer;

  i {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    animation: bounce 1.2s infinite;
  }
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(4px); }
}
</style>
